const consentScript = document.createElement('script');

consentScript.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
consentScript.setAttribute('data-document-language', 'true');
consentScript.setAttribute('type', 'text/javascript');
consentScript.setAttribute('charset', 'UTF-8');

if (import.meta.env.VITE_APP_env === 'production') {
  consentScript.setAttribute('data-domain-script', 'fd8e360c-755e-4df9-af9b-9afc76555f18');
} else {
  consentScript.setAttribute('data-domain-script', 'fd8e360c-755e-4df9-af9b-9afc76555f18-test');
}

document.body.appendChild(consentScript);
